var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { noneStyle } from '../../../../../../helpers/common';
import { propShape, propStr } from '../../../../../../helpers/custom-prop-types';
import SubmitButton from '../../../../Button/SubmitButton';
import Image from '../../../../Common/Image';
import InputError from '../../../../Common/InputError';
const SolutionBaseFileImage = (props) => {
    const { accept, defaultFileUrl, input, meta, submitButtonClassName } = props;
    const { value: _value } = input, addProps = __rest(input, ["value"]);
    const fileInputRef = useRef();
    const onClickButton = useCallback(() => {
        fileInputRef.current.click();
        return false;
    }, []);
    const onChange = useCallback((e) => {
        if (!e.currentTarget.files.length) {
            return;
        }
        input.onBlur(e.currentTarget.files[0]);
    }, [input]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx("input", Object.assign({}, addProps, { accept: accept, onChange: onChange, ref: fileInputRef, style: noneStyle, type: 'file' })), _jsx(SubmitButton, { buttonType: 'button', className: submitButtonClassName, isDisabled: false, isLoading: false, onClick: onClickButton, text: 'ファイル選択' })] }), _jsx(InputError, { meta: meta }), (input.value || defaultFileUrl) && (_jsx("div", Object.assign({ className: 'image_preview_box' }, { children: _jsx(Image, { alt: '', isObjectFit: true, src: input.value || defaultFileUrl, useImage: true }) })))] }));
};
SolutionBaseFileImage.propTypes = {
    accept: propStr().isRequired,
    defaultFileUrl: propStr(),
    input: propShape().isRequired,
    meta: propShape().isRequired,
    submitButtonClassName: propStr().isRequired,
};
SolutionBaseFileImage.defaultProps = {
    defaultFileUrl: '',
};
export default SolutionBaseFileImage;
